import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-356be0e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weChannels" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "● ", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "alarms"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "alarms"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "alarms"
}
const _hoisted_10 = { key: 1 }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {getListData} from '@/service/main/system'
import dayjs from "dayjs";
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref} from "vue";
import {
  getThresholds
} from "@/service/main/thirdPartyLive";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveStreamingData',
  setup(__props) {

initEmptyParam()
const store = useStore()
let accountData=ref([])
let queryParam = ref({dataTime: dayjs().startOf('date').format('YYYY-MM-DD')})

store.commit('system/changeQueyryInfo', queryParam.value)

const uvCountObj =  ref<any>({})
const getDetail = () => {
    getThresholds().then(res=>{
      uvCountObj.value = res
    })
}
getDetail()

const getCompanyList = async () => {
  accountData.value = await getListData('/main/weChannels/thirdParties', {})
  // queryParam.value = {
  //     dataTime: dayjs().startOf('date').format('YYYY-MM-DD'),
  //     thirdParty:accountData.value[0]
  //   }
  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'thirdParty'
  )
  roleItem!.options = accountData.value.map((item: any) => {
    return {title: item, value:  item}
  })
    // const queryInfo = store.state.system.queryInfo
    // pageContentRef.value?.getPageData(queryInfo)
}
 getCompanyList()



// const handleSortChange = (value: any) => {
//   console.log(value)
//   store.commit('system/changeOrderInfo', {
//     orderBy: value.prop,
//     orderType: value.order
//   })
//   const queryInfo = store.state.system.queryInfo
//   pageContentRef.value?.getPageData(queryInfo)
// }



const resetCb = () => {
  return queryParam.value
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] =
  usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "weChannels"
    }, {
      thirdParty: _withCtx((scope) => [
        _createVNode(_component_el_tag, { type: "warning" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.thirdParty), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      liveStatus: _withCtx((scope) => [
        (scope.row.liveStatus === '直播中')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" 直播中")
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, " ● " + _toDisplayString(scope.row.liveStatus), 1))
      ]),
      watchUv: _withCtx((scope) => [
        (scope.row.watchUv > uvCountObj.value?.watch_uv)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(scope.row.watchUv), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(scope.row.watchUv), 1))
      ]),
      newFollowUv: _withCtx((scope) => [
        (scope.row.newFollowUv > uvCountObj.value?.new_follow_uv)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(scope.row.newFollowUv), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(scope.row.newFollowUv), 1))
      ]),
      shareUv: _withCtx((scope) => [
        (scope.row.shareUv > uvCountObj.value?.share_uv)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(scope.row.shareUv), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(scope.row.shareUv), 1))
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})